import React from "react";
import i18n from "i18next";
import { ColumnsType } from "antd/lib/table/interface";
import { Signatory } from "@type/core/dashboard/dashboard.types";
import UnlockIcon from "@static/core/icons/icon-unlock.svg?react";
import LockIcon from "@static/core/icons/icon-lock.svg?react";
import { TRANSACTION_STATUS_ENUM } from "@utils/Constant";
import parse from "html-react-parser";
import DateFormat from "@utils/DateFormat";
import { setSignatoryColor } from "@utils/helpers/signatories-helper";
import BasicButton from "@components/core/buttons/BasicButton";
import BasicProgress from "@components/core/progress/BasicProgress";
import { TransactionDetail } from "@/type/core/transaction/transaction.types";

export const columns = (): ColumnsType<TransactionDetail> => [
  {
    title: "",
    dataIndex: "confidential",
    className: "px-0",
    render: (confidential: boolean, record: TransactionDetail) => {
      return !confidential ? (
        <></>
      ) : record.authorized ? (
        <UnlockIcon className="table-unlock" />
      ) : (
        <LockIcon className="table-lock" />
      );
    },
  },
  {
    title: i18n.t("home.dashboard.table.reference"),
    dataIndex: "reference",
    className: "table-object",
  },
  {
    title: i18n.t("home.dashboard.table.progression"),
    dataIndex: "signatories",
    className: "table-progress",
    onCell: () => {
      return {
        onClick: (e: React.MouseEvent<HTMLAnchorElement>) => {
          e.stopPropagation();
        },
      };
    },
    render: (
      signatories: Signatory[] | undefined,
      record: TransactionDetail,
    ) => {
      const totalNumberSignatories = signatories ? signatories.length : 0;
      const signedNumberSignatories = signatories
        ? signatories.filter((signatory) => signatory.status === "signed")
            .length
        : 1;
      return (
        totalNumberSignatories > 0 &&
        record.status !== "draft" &&
        record.status !== "prepared" &&
        (record.signatureRequirementMode === "SOME" ? (
          i18n.t("home.dashboard.table.combined")
        ) : (
          <BasicProgress
            percent={(signedNumberSignatories / totalNumberSignatories) * 100}
            label={`${signedNumberSignatories}/${totalNumberSignatories}`}
          />
        ))
      );
    },
  },
  {
    title: i18n.t("home.dashboard.table.alias"),
    dataIndex: "officeName",
  },
  {
    title: i18n.t("home.dashboard.table.status"),
    dataIndex: "status",
    render: (status: string, record: TransactionDetail) => {
      let statusLabel = "";
      for (const key in TRANSACTION_STATUS_ENUM) {
        const statusEnum = TRANSACTION_STATUS_ENUM[key];
        if (statusEnum[0] === status) {
          statusLabel = statusEnum[1];
        }
      }
      return record.classified
        ? i18n.t(TRANSACTION_STATUS_ENUM.CLASSIFIED[0])
        : parse(statusLabel);
    },
  },
  {
    title: i18n.t("home.dashboard.table.modificationDate"),
    dataIndex: "modificationDate",
    render: (modificationDate: string) => {
      return DateFormat.dashboardDate(new Date(modificationDate));
    },
  },
  {
    title: i18n.t("home.dashboard.table.sendBy"),
    dataIndex: "sendBy",
  },
  {
    title: i18n.t("home.dashboard.table.signatories"),
    dataIndex: "signatories",
    className: "table-signatories",
    render: (signatories: Signatory[], record: TransactionDetail) => {
      return (
        <ul>
          {signatories &&
            signatories.map((signatory, index) => (
              <li key={index} className={"custom-control-label"}>
                {setSignatoryColor(signatory, record.status ?? "")}
              </li>
            ))}
        </ul>
      );
    },
  },
  {
    title: i18n.t("home.dashboard.table.expirationDate"),
    dataIndex: "expirationDate",
    render: (expirationDate: string) => {
      return (
        expirationDate && DateFormat.dashboardDate(new Date(expirationDate))
      );
    },
  },
  {
    title: "",
    dataIndex: "invitationMode",
    onCell: () => {
      return {
        onClick: (e: React.MouseEvent<HTMLAnchorElement>) => {
          e.stopPropagation();
        },
      };
    },
    render: (_, record: TransactionDetail) => {
      return (
        <BasicButton
          text={i18n.t("home.dashboard.table.buttons.sign")}
          className="w-100"
          onClick={() => window.open(record?.url, "_self")}
        />
      );
    },
  },
];
